<template>
  <div>
    <v-tabs grow color="secondary" v-model="reportTab">
      <v-tab
        v-for="(page, id) in reportPages"
        :key="id"
        @click="report.setPage(page.name)"
      >
        {{ page.displayName }}
      </v-tab>
    </v-tabs>
    <div id="reportContainer">
      <!-- <iframe
        title="Equipacare Dummy"
        width="1140"
        height="541.25"
        src="https://app.powerbi.com/reportEmbed?reportId=0ec21473-9d15-4e01-a3f2-7c9c1353f4b7&autoAuth=true&ctid=08f25003-a45c-49fb-8090-a8e9c45925d6"
        frameborder="0"
        allowFullScreen="true"
      ></iframe> -->
    </div>
  </div>
</template>

<script>
import * as pbi from 'powerbi-client'
import ApiService from '../../../services/ApiService'

export default {
  data() {
    return {
      report: null,
      reportTab: null,
      reportPages: [],
      apiService: new ApiService(),
      tokens: {},
    }
  },

  async mounted() {
    await this.getToken()
    try {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      const powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      )

      let models = pbi.models

      // var basicFilter4 = {
      //   $schema: 'http://powerbi.com/product/schema#basic',
      //   target: {
      //     table: 'serviceorders',
      //     column: 'InstitutionId',
      //   },
      //   operator: 'In',
      //   values: [institutionId],
      //   filterType: 1,
      // }

      // var basicFilter5 = {
      //   $schema: 'http://powerbi.com/product/schema#basic',
      //   target: {
      //     table: 'unidade',
      //     column: 'InstitutionId',
      //   },
      //   operator: 'In',
      //   values: [institutionId],
      //   filterType: 1,
      // }

      // var basicFilter5 = {
      //   $schema: 'http://powerbi.com/product/schema#basic',
      //   target: {
      //     table: 'calleds',
      //     column: 'InstitutionId',
      //   },
      //   operator: 'In',
      //   values: [institutionId],
      //   filterType: 1,
      // }

      // var basicFilter6 = {
      //   $schema: 'http://powerbi.com/product/schema#basic',
      //   target: {
      //     table: 'equipment',
      //     column: 'InstitutionId',
      //   },
      //   operator: 'In',
      //   values: [institutionId],
      //   filterType: 1,
      // }

      let embedConfiguration = {
        type: 'report',
        id: '3f2a01ca-abf7-4efe-b5cf-b03797703e2f',
        embedUrl:
          'https://app.powerbi.com/reportEmbed?reportId=3f2a01ca-abf7-4efe-b5cf-b03797703e2f&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUJSQVpJTC1TT1VUSC1CLVBSSU1BUlktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7InVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3D',
        tokenType: models.TokenType.Embed,
        accessToken: this.tokens.token,
        permissions: models.Permissions.All,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false,
        },
      }

      let reportContainer = document.getElementById('reportContainer')

      this.report = powerbi.embed(reportContainer, embedConfiguration)

      const self = this

      this.report.on('loaded', (event) => {
        this.report.getFilters().then(async (filters) => {
          // filters.push(...[basicFilter4, basicFilter5])

          self.reportPages = await self.report.getPages()

          self.reportPages = self.reportPages

          self.report.setPage(self.reportPages[0].name)

          return self.report.setFilters(filters)
        })
      })
    } catch (err) {}
  },

  methods: {
    async getToken() {
      await this.apiService
        .get(
          'consumptionReading/getAccessToken?reportId=3f2a01ca-abf7-4efe-b5cf-b03797703e2f&datasetId=60bd760e-25de-4e41-a01f-45ced8216ecf'
        )
        .then((response) => {
          this.tokens = response.content
        })
    },
  },
}
</script>

<style scoped>
#reportContainer {
  height: 90vh;
  width: 100% !important;
}
</style>
